<div
  class="border-card border-0 px-4 py-1 scroll-container"
  ref="DataPointView"
>
  <!-- Stats Cards Row -->
  <div class="row mt-3">
    <!-- Total Data Points -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-database fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Total Data Points</p>
              <p class="m-0 fw-bold text-white">{{ data_points.length }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Active Data Points -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-check-circle fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Active Data Points</p>
              <p class="m-0 fw-bold text-white">{{ active_data_points_count }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recently Added -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-plus-circle fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Recently Added</p>
              <p class="m-0 fw-bold text-white">{{ recent_data_points_count }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recently Updated -->
    <div class="col-12 col-sm-6 col-md-3 mb-3 d-flex">
      <div class="w-100 h-100">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fa-solid fa-pen-to-square fa-lg text-primary-blue"></i>
            </div>
            <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
              <p class="mb-1 text-xs text-white">Recently Updated</p>
              <p class="m-0 fw-bold text-white">{{ updated_data_points_count }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Data Points Table -->
  <div class="card rounded-lg border-0 shadow mt-2">
    <div class="card-header bg-white border-0 rounded-lg mt-3">
      <p class="text-s">Data Point Management</p>
      <button
        
        class="btn btn-primary-dark btn-sm shadow text-xxs"
        data-bs-toggle="modal"
        data-bs-target="#create_data_point_modal"
        :disabled="loading"
      >
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-1"
        ></span>
        Create Data Point
      </button>
      <button
        data-bs-toggle="modal"
        data-bs-target="#assign_data_point_modal"
        class="btn btn-primary-dark btn-sm shadow text-xxs ms-2"
        @click="fetch_current_assignments"
        :disabled="loading"
      >
        Create Tag Assignment
      </button>
    </div>
    <div class="card-body">
      <GlobalTable
        
        :headers="['ID', 'Name', 'Description', 'Date Created', 'Updated At']"
        :data="table_safe_data_points"
        :table_id="'data_points_table'"
      >
        <template #actions="{ row }">
          <button
            class=" d-none btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            data-bs-toggle="modal"
            data-bs-target="#view_data_point_modal"
            @click="select_data_point(row)"
            :disabled="loading"
          >
            View
          </button>
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            data-bs-toggle="modal"
            data-bs-target="#update_data_point_modal"
            @click="select_data_point(row)"
            :disabled="loading"
          >
            Update
          </button>
          <button
            class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs"
            @click="delete_data_point(row.id)"
            :disabled="loading"
          >
            Delete
          </button>
        </template>
      </GlobalTable>
    </div>
  </div>

  <!-- Create Data Point Modal -->
  <teleport to="body">
    <div
      class="modal fade"
      id="create_data_point_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 custom-header shadow-lg">
            <h5 class="modal-title text-xxs">Create New Data Point</h5>
            <button
              type="button"
              class="modal-btn-close btn-close shadow-none"
              data-bs-dismiss="modal"
              aria-label="Close"
              :disabled="loading"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label
                for="data_point_name"
                class="modal-form-label form-label text-xxs"
                >Name *</label
              >
              <input
                v-model="new_data_point.name"
                class="modal-form-control form-control text-xxs"
                type="text"
                placeholder="E.g. Customer Details"
                :disabled="loading"
              />
            </div>
            <div class="mb-3">
              <label
                for="data_point_description"
                class="modal-form-label form-label text-xxs"
                >Description</label
              >
              <textarea
                v-model="new_data_point.description"
                class="modal-form-control form-control text-xxs"
                rows="3"
                placeholder="Briefly describe what this data point will hold. For example: This data point will contain tags like 'First Name', 'Last Name', and 'Email Address'."
                :disabled="loading"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm text-xxs shadow-sm"
              @click="create_data_point"
              :disabled="loading"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm me-1"
                data-bs-dismiss="modal"
              ></span>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>


  <!-- View Data Point Modal -->
<teleport to="body">
  <div
    class="modal fade"
    id="view_data_point_modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-3">
        <div class="modal-header border-bottom-0 custom-header text-white">
          <h5 class="modal-title text-xxs">
            Viewing - {{ selected_data_point.data_point_name }}
          </h5>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label text-xxs">Name:</label>
                <p class="text-xsm">
                  {{ selected_data_point.data_point_name }}
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label text-xxs">Date Created:</label>
                <p class="text-xsm">
                  {{ format_date(selected_data_point.date_created) }}
                </p>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label text-xxs">Description:</label>
            <p class="text-xsm">
              {{ selected_data_point.data_point_description }}
            </p>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</teleport>


  <!-- Update Data Point Modal -->
<teleport to="body">
  <div
    class="modal fade"
    id="update_data_point_modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div
          class="modal-header border-bottom-0 custom-header text-white shadow-lg"
        >
          <p class="modal-title text-xxs">Update Data Point</p>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            :disabled="loading"
          ></button>
        </div>
        <div class="modal-body">
          <div class="modal-form-group form-group mb-3">
            <label
              for="update_data_point_name"
              class="modal-form-label form-label text-xxs"
              >Name *</label
            >
            <input
              v-model="selected_data_point.data_point_name"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              type="text"
              placeholder="Data point name"
              :disabled="loading"
            />
          </div>
          <div class="modal-form-group form-group mb-3">
            <label
              for="update_data_point_description"
              class="modal-form-label form-label text-xxs"
              >Description</label
            >
            <textarea
              v-model="selected_data_point.data_point_description"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              rows="3"
              placeholder="Data point description"
              :disabled="loading"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="update_data_point"
            :disabled="loading"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

  <!-- Assign Data Point Modal -->
<teleport to="body">
  <div>
    <div
      class="modal fade"
      id="assign_data_point_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header custom-header">
            <h5
              class="modal-title text-uppercase text-xxs font-weight-bolder text-white opacity-7"
            >
              Manage Tag Assignments
            </h5>
            <button
              type="button"
              class="btn-close shadow-none"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body py-3">
            <!-- Section 1: Assign New Tag -->
            <div class="card mb-4">
              <div class="card-header">
                <p class="mb-0 fw-bold text-x">
                  {{ is_editing_tag ? 'Edit Tag' : 'Assign New Tag' }}
                </p>
              </div>
              <div class="card-body">
                <p class="text-xxs text-muted mb-3">
                  {{ is_editing_tag 
                    ? 'Update your tag details below and click Save when done.' 
                    : 'Tags link questions to answers and must be assigned to a data point. To create a tag, type its name, select the related data point, and choose a tag type.' 
                  }}
                </p>

                <div class="row">
                  <div class="col-md-4">
                    <label for="newTagName" class="form-label text-xxs"
                      >Tag Name</label
                    >
                    <input
                      type="text"
                      class="form-control text-xxs"
                      id="newTagName"
                      v-model="new_tag_name"
                      placeholder="E.g. First Name, Age, Country"
                    />
                  </div>
                  <div class="col-md-4">
                    <label for="dataPointSelect" class="form-label text-xxs"
                      >Data Point</label
                    >
                    <select
                      class="form-select text-xxs"
                      id="dataPointSelect"
                      v-model="selected_data_point_id"
                      :disabled="is_editing_tag"
                    >
                      <option value="">Select a data point</option>
                      <option v-for="dp in data_points" :value="dp.id">
                        {{ dp.data_point_name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label for="tagTypeSelect" class="form-label text-xxs"
                      >Tag Type</label
                    >
                    <select
                      class="form-select text-xxs"
                      id="tagTypeSelect"
                      v-model="selected_tag_type"
                    >
                      <option value="">Select a tag type</option>
                      <option v-for="type in tag_types" :value="type.value">
                        {{ type.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="row mt-3"
                  v-if="['select', 'radio', 'multiple'].includes(selected_tag_type)"
                >
                  <div class="col-md-12">
                    <label for="tagOptions" class="form-label text-xxs"
                      >Options (comma separated)</label
                    >
                    <input
                      type="text"
                      class="form-control text-xxs"
                      id="tagOptions"
                      v-model="tag_options"
                      placeholder="E.g. Option1, Option2, Option3"
                    />
                  </div>
                </div>
                <div class="mt-3">
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark"
                    @click="is_editing_tag ? update_tag() : assign_new_tag()"
                    :disabled="(!new_tag_name || !selected_data_point_id) || (is_editing_tag ? update_loading : assignment_loading)"
                  >
                    <span
                      v-if="is_editing_tag ? update_loading : assignment_loading"
                      class="spinner-border spinner-border-sm me-1"
                    ></span>
                    {{ is_editing_tag ? 'Save' : 'Assign' }}
                  </button>
                  <button
                    v-if="is_editing_tag"
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark ms-2"
                    @click="cancel_edit"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Section 2: Current Assignments -->
            <div class="card">
              <div class="card-header">
                <h6 class="mb-0 fw-bold text-x">Current Assignments</h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-hover w-100"
                    id="current_assignments_table"
                  >
                    <thead class="custom-header">
                      <tr>
                        <th
                          class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start"
                        >
                          Tag Name
                        </th>
                        <th
                          class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start"
                        >
                          Data Point
                        </th>
                        <th
                          class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="assignment in current_assignments"
                        :key="assignment.id"
                      >
                        <td class="text-xxs text-start">
                          {{ assignment.tag_name }}
                        </td>
                        <td class="text-xxs text-start">
                          {{ assignment.data_point_name }}
                        </td>
                        <td class="text-xxs text-start">
                          <button
                            class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs me-2"
                            @click="edit_tag(assignment)"
                            :disabled="assignment.is_loading"
                          >
                            <span
                              v-if="assignment.is_loading"
                              class="spinner-border spinner-border-sm me-1"
                            ></span>
                            Update
                          </button>
                          <button
                            class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs"
                            @click="unassign_tag(assignment)"
                            :disabled="assignment.is_loading"
                          >
                            <span
                              v-if="assignment.is_loading"
                              class="spinner-border spinner-border-sm me-1"
                            ></span>
                            Unassign
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    v-if="current_assignments.length === 0"
                    class="text-center py-4"
                  >
                    <p class="text-muted text-xxs">No tag assignments found</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
</div>
